import Vue from "vue"
import Vuex from "vuex"
import VuexPersist from "vuex-persist"
import state from "./state"
import commonMutations from "./mutations/commonMutations"
import commonActions from "./actions/commonActions"

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: localStorage
  //reducer: state => ({ currentUser: state.currentUser })
})

var mutations = Object.assign({}, commonMutations)
var actions = Object.assign({}, commonActions)
const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state,
  actions,
  mutations,
  getters: {
    currentTournamentId: state => {
      const recent = state.recentTournaments
      if (recent && recent.length > 0) return recent[recent.length - 1].id
      return undefined
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js